export default "__VITE_ASSET__BCyuLMi2__"